
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"coppa\" class=\"input-row input-row-age\">\n  <label class=\"label-helper\"></label>\n  <input type=\"number\" id=\"age\" placeholder=\"{{#t}}How old are you?{{/t}}\" min=\"0\" max=\"999\" value=\"{{ age }}\" {{#required}}required{{/required}} />\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/partial/coppa-age-input.mustache
// module id = 259
// module chunks = app